module.exports = __webpack_public_path__ + "img/appraisalA.85bdb529.png";